import React from "react"
import { ResponsiveHeatMap } from '@nivo/heatmap'
import {
    Container,
    Col,
    Row,
} from 'reactstrap'
import Topics from "./data/Topics.js"


class DecadeViz extends React.Component {
    constructor(props) {
        super(props);
      }

    render() {
        
        return(
              <div>
                  <Container fluid className="no-gutters whiteback no-padding">
                  <Row style={{ height: this.props.height }} className="no-gutters dataviz justify-content-center">
                        <Col lg="8" md="10" xs="12" className="text-left">
                        <div className="topicpattern">
                            <div className="topicbox"></div>
                            <div className="topicbox israelc">{Topics[0].topicAR}</div>
                            <div className="topicbox nuclearc">{Topics[1].topicAR}</div>
                            <div className="topicbox armsc">{Topics[2].topicAR}</div>
                            <div className="topicbox humanrightsc">{Topics[4].topicAR}</div>
                            <div className="topicbox colonialismc">{Topics[3].topicAR}</div>
                            <div className="topicbox economicc">{Topics[5].topicAR}</div>
                            <div className="topicbox"></div>
                        </div>
        <ResponsiveHeatMap
        data={this.props.dataset}
        keys={[
            "OZ",
            "ME",
            "NU",
            "DI",
            "HR",
            "CO",
            "EC",
            "OT"
        ]}
        indexBy={this.props.language}
        enableLabels={false}
        colors={["#ffffff"]}
        margin={{ top: 0, right: 0, bottom: 0, left:0 }}
        pixelRatio={2}
        minValue="auto"
        maxValue="auto"
        forceSquare={false}
        sizeVariation={1}
        padding={0}
        axisTop={{ orient: 'top', tickSize: 5, tickPadding: 5, tickRotation: -90, legend: '', legendOffset: 36 }}
        axisLeft={null}
        axisBottom={null}
        axisTop={null}
        axisRight={null}
        enableGridX={false}
        enableGridY={true}
        cellShape="rect"
        cellOpacity={1}
        cellBorderWidth={0}
        cellBorderColor={{ from: 'color', modifiers: [ [ 'darker', 0.2 ] ] }}
        labelTextColor={{ theme: 'background' }}
        animate={false}
        motionStiffness={120}
        motionDamping={9}
        isInteractive={true}
        hoverTarget="rowColumn"
        cellHoverOpacity={1}
        cellHoverOthersOpacity={0.1}
        height={this.props.height}
    />
    </Col>
    </Row>
    </Container>
      </div>
    )
}
}
export default DecadeViz
